module.exports = __webpack_public_path__ + "img/DOT.486e7eef.svg";